// Money is represented in integer minor units (paise) everywhere in the catalog +
// cart engine + pricing. Format to rupees only for display.
export const paiseToRupees = (p) => Number(p || 0) / 100;
export const rupeesToPaise = (r) => Math.round(Number(r || 0) * 100);
export const formatINR = (p) => `₹${(Number(p || 0) / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
